import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import translationHE from "./Components/Languages/he/translation.json"
import translationEN from "./Components/Languages/en/translation.json"
import translationRU from "./Components/Languages/ru/translation.json"

const resources = {
  he: { translation: translationHE },
  en: { translation: translationEN },
  ru: { translation: translationRU },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["he", "en", "ru"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      
      // Кастомное имя ключа для localStorage
      lookupLocalStorage: "language", 
      
      // Форматируем язык перед сохранением
      convertDetectedLanguage: (lng) => lng.split("-")[0],
    },
  })

export default i18n